import axios from "axios";
import { useEffect, useState } from "react";
import { get_sort_dropdown } from "../../api/api";



const FilterReportsSort = ({ reportSort, defaultValue = 0 }) => {

    const [dropDown, setDropDown] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const getDropDown = async () => {
            try {
                setIsLoading(true)
                const res = await axios.get(get_sort_dropdown())
                setDropDown(res.data)
            } finally {
                setIsLoading(false)
            }
        }
        getDropDown()
    }, []);


    return (!isLoading && <>
        <div className="flexRow">
            <select className="whiteBoy" id="sortType" onChange={(e) => reportSort(e.target.value)} value={defaultValue}>
                {dropDown && dropDown.map(item => (
                    <option key={item.id} value={item.id}>{item.title}</option>
                ))}
            </select>
        </div>
    </>);
}

export default FilterReportsSort;